import React, {useState} from 'react'
import {
    SalaryIcon,
    SalaryUpdateActions,
    SalaryUpdateButtonContainer,
    SalaryUpdateContainer,
    SalaryUpdateMessage,
    SalaryUpdateTitle
} from "./styles";
import {useTranslation} from "react-i18next";
import {Employee} from "../../../app/interfaces";
import {ReactComponent as Alert} from '../../../assets/icons/alert_yellow.svg'
import {ReactComponent as Check} from '../../../assets/icons/check.svg'
import {ReactComponent as Close} from '../../../assets/icons/close.svg'
import {SalaryRejectionModal} from "./SalaryRejectionModal";
import {
    FETCH_STATUS_LOADING,
} from "../../../utils/constants";
import {useDispatch, useSelector} from "react-redux";

import {
    PopupAskForConfirmation,
    PopupLoading,
    PrimaryButtonAccent,
    SecondaryButton
} from "../../../components";
import {approveSalaryUpdate} from "../../../app/employee/actions";
import {updateEmployeeState} from "../../../app/employee/selectors";
const SalaryUpdateRequested = ({employee}: { employee: Employee }) => {
    const [showApproveModal, setShowApproveModal] = useState<boolean>(false)
    const [showRejectModal, setShowRejectModal] = useState<boolean>(false)
    const [showRejectExplanationModal, setShowRejectExplanationModal] = useState<boolean>(false)
    const dispatch = useDispatch()
    const updateStatus = useSelector(updateEmployeeState);

    const {t} = useTranslation()

    const handleApprove = () => {
        dispatch(approveSalaryUpdate({
            employeeId: employee._id,
            companyId: employee.company._id,
        }) as any)
    }

    const dateOptions = {year: 'numeric', month: 'long', day: 'numeric'}

    if(updateStatus === FETCH_STATUS_LOADING){
        return <PopupLoading isOpen={true}/>
    }

    if(employee.salary_change_requested?.status === 'approved'){
        return null;
    }

    return <SalaryUpdateContainer>
        <PopupAskForConfirmation
            isOpen={showApproveModal}
            onConfirm={() => {
                setShowApproveModal(false)
                handleApprove()
            }}
            onCancel={() => setShowApproveModal(false)}
            title={t('confirm_salary_update_title') as string}
            subtitle={t('confirm_salary_update_message', {
                // @ts-ignore
                effective_date: new Date(employee.salary_change_requested?.effective_date).toLocaleDateString('en', dateOptions)
            }) as string}
            type='warning'
        />
        <PopupAskForConfirmation
            isOpen={showRejectModal}
            onConfirm={() => {
                setShowRejectModal(false)
                setShowRejectExplanationModal(true)
            }}
            onCancel={() => setShowRejectModal(false)}
            title={t('confirm_salary_reject_title') as string}
            subtitle={t('confirm_salary_reject_message') as string}
            type='hand_stop'
        />
        <SalaryRejectionModal
            employee={employee}
            isOpen={showRejectExplanationModal}
            onClose={() => setShowRejectExplanationModal(false)}
        />
        <SalaryIcon>
            <Alert/>
        </SalaryIcon>
        <SalaryUpdateActions>
            <SalaryUpdateTitle>
                {t('salary_update_requested_title')}
            </SalaryUpdateTitle>
            <SalaryUpdateMessage>
                {t('salary_update_requested_message', {
                    old_salary: employee.salary.amount,
                    new_salary: employee.salary_change_requested?.amount,
                    // @ts-ignore
                    effective_date: new Date(employee.salary_change_requested?.effective_date).toLocaleDateString('en', dateOptions)
                })}
            </SalaryUpdateMessage>
            <SalaryUpdateButtonContainer>
                <PrimaryButtonAccent onClick={() => setShowApproveModal(true)}>
                    {t('approve')}
                    <Check/>
                </PrimaryButtonAccent>
                <SecondaryButton onClick={() => setShowRejectModal(true)}>
                    {t('reject')}
                    <Close/>
                </SecondaryButton>
            </SalaryUpdateButtonContainer>
        </SalaryUpdateActions>
    </SalaryUpdateContainer>
}

export default SalaryUpdateRequested
